import FormDamages from "../../../../Components/FormDamages";
import { damageComponents, damageTypes } from "../../../../system/damages";
import { Form } from "../../../../system/useForm";

const DAP05RemarksInterior = ({ form }: { form: Form }) => {
	return (
		<FormDamages
			name="remarks.toInteriors"
			form={form}
			damageTypes={damageTypes.interior}
			damageComponents={damageComponents.interior}
		/>
	);
};

export default DAP05RemarksInterior;
